import React, { useRef } from "react"
import { Portal } from "components"
import styles from "css/Layer.module.css"
import { AnimatePresence, motion } from "framer-motion"

const LayerBottom = ({ conHeight, className, noDim, show, title, closeLayer, children, outside, wrapStyle, closeButton = true, scroll = true }) => {
	const win = useRef()

	//#region Methods
	const onClose = () => {
		if (closeLayer) closeLayer(false)
	}
	//#endregion

	//#region Variants
	const variants = {
		initial: {
			backdropFilter: "blur(0px)",
			WebkitBackdropFilter: "blur(0px)",
			backgroundColor: "rgba(0, 0, 0, 0)",
		},
		animate: {
			backdropFilter: "blur(5px)",
			WebkitBackdropFilter: "blur(5px)",
			backgroundColor: "rgba(0, 0, 0, 0.6)",
		},
		noDim: {
			backdropFilter: "none",
			WebkitBackdropFilter: "none",
			backgroundColor: "transparent",
		},
	}

	const winVariants = {
		initial: {
			y: 0,
			transition: {
				type: "tween",
				duration: 0.2,
			},
		},
		animate: {
			y: "-100%",
			transition: {
				type: "tween",
				duration: 0.2,
			},
		},
	}
	//#endregion

	return (
		<Portal>
			<AnimatePresence>
				{show && (
					<motion.div variants={variants} initial='initial' animate={noDim ? "noDim" : "animate"} exit='initial' className={`layer ${styles.layerBottom} ${className}`}>
						<motion.div ref={win} variants={winVariants} initial='initial' animate='animate' exit='initial' className={styles.bottomWin} style={noDim ? { boxShadow: "0 -1rem 1rem rgb(0 0 0 / 20%)" } : undefined}>
							{title && <div className={styles.title}>{title}</div>}
							<div className={`layerContent ${styles.wrap}${title ? ` ${styles.withTitle}` : ""}${noDim ? ` ${styles.dwarf}` : ""}${scroll ? " overflow-y_auto" : ""}`} style={{ ...wrapStyle, height: `${conHeight}px` }}>
								<div>{children}</div>
							</div>
							{outside && outside}
							{closeButton && <i className={`icon_close${title ? ` ${styles.withTitle}` : ""}`} onClick={onClose} />}
						</motion.div>
					</motion.div>
				)}
			</AnimatePresence>
		</Portal>
	)
}

export default LayerBottom
